import { useDispatch } from 'react-redux';
import { useStatus, LOADING } from '@rootstrap/redux-tools';

import {registerEvent } from 'state/actions/membershipActions';

export default () => {
  const dispatch = useDispatch();
  const { status, error } = useStatus(registerEvent);

  const eventAd = async membership => {
    const { creditCardId, eventId, register } = membership;
    return dispatch(registerEvent(creditCardId, eventId, register)); 
  };
  

  return {
    loading: status === LOADING,
    error,
    eventAd,
    status
  };
};
